import * as React from "react";
import PropTypes from "prop-types";
import { withRouter, Redirect } from "react-router-dom";
import PrivateRoute from "components/Router/PrivateRoute";

import PublicRoute from "components/Router/PublicRoute";
import HomeownerIntro from "portal_homeowner/intro";

import Layout from "../layout";
import Sidebar from "../sidebar";

import auth_routes from "../Auth/routes";
import user_routes from "../User/routes";
import lots_routes from "../Lots/routes";

import auth from "../Auth/authenticator";
import { checkRoute, checkAllSystemRoute } from "../helper/check-route-helper";
import { AppSettings } from "../constants";
import HomeOwnerManageLot from "Lots/Containers/lot-list";
import RFSDetail from "../Request-Services/Containers/RFSDetail";
import EocListItems from "../Request-Services/Containers/eoc-list-items";
import work_order_routes from "../Work-Orders/routes";

import NotFoundPage from "errorPage/404";
import AccessDeniedPage from "errorPage/403";

class AppRoutes extends React.Component {
  static propTypes = {
    history: PropTypes.any,
    authenticated: PropTypes.bool,
    location: PropTypes.object,
  };

  constructor(props) {
    super(props);
  }

  renderRoutes = () => {
    let routes = [];
    const work_order_router = work_order_routes.filter(
      (route) => route.path !== "/work-order-list"
    );
    routes = [].concat(
      auth_routes,
      user_routes,
      lots_routes,
      work_order_router
    );
    routes.push({
      path: "/lots",
      component: HomeOwnerManageLot,
      private: true,
    });
    routes.push({
      path: "/request-for-services/:RFSID",
      component: RFSDetail,
      private: true,
    });
    routes.push({
      path: "/request-for-services/electronic-orientation-checklists/:RFSID",
      component: EocListItems,
      private: true,
    });
    localStorage.getItem(AppSettings.IS_SSO_USER) === 'True' &&AppSettings.clientTypeValue === 'Homeowner'?
    routes.push({
      path: "/",
      component: HomeOwnerManageLot,
      private: true,
      portal: ['Homeowner'],
    })
    :
    routes.push(
      {
        path: '/',
        component: HomeownerIntro,
        private: true,
        portal: ['Homeowner'],
        menu: {
          name: 'Welcome',
          order: 1,
          icons: 'pe-7s-compass',
          condition: () => {
            return AppSettings.clientTypeValue === 'Homeowner'&&localStorage.getItem(AppSettings.IS_SSO_USER) === 'False';
          },
        },
      }
    )
    return routes;
  };

  renderSidebar = (roleName, routes) => {
    let groupMenu = null;
    if (roleName === AppSettings.SYSTEM_ADMINISTRATOR) {
      groupMenu = {
        Admin: {
          icon: "pe-7s-photo-gallery",
          name: "Admin utilities",
        },
      };
    } else {
      groupMenu = {};
    }
    return (
      <Sidebar
        key="sidebar"
        routes={routes}
        groupMenu={groupMenu}
        location={this.props.location}
      />
    );
  };
  render() {
    const authenticated = auth.loggedIn();
    const roleName = auth.getRoleName();
    var routes = this.renderRoutes(roleName);
    console.log("now route", routes);
    let privateRoute = null;
    let publicRoute = null;

    const matchRoute = checkRoute(routes, this.props.location.pathname);

    const nextUrl = this.props.location.pathname;

    if (matchRoute) {
      if (matchRoute.private) {
        privateRoute = matchRoute;
      } else {
        publicRoute = matchRoute;
      }
    }

    const queryParams = new URLSearchParams(this.props.location.search);
    const isPublic = queryParams.get("public");

    if (privateRoute) {
      if (!localStorage[AppSettings.S1_TOKEN]) {
        if (isPublic || isPublic === "true") {
          return (
            <Redirect to={`/public${nextUrl}${this.props.location.search}`} />
          );
        } else {
          return (
            <Redirect
              to={`/sign-in?nextUrl=${nextUrl}${this.props.location.search}`}
            />
          );
        }
      }

      return (
        <Layout
          history={this.props.history}
          routes={routes}
          location={this.props.location}
          renderSidebar={() => this.renderSidebar(roleName, routes)}
        >
          <PrivateRoute
            authed={authenticated}
            component={privateRoute.component}
            exact
            path={privateRoute.path}
            key={"private"}
          />
        </Layout>
      );
    }
    if (publicRoute) {
      return (
        <PublicRoute
          authed={authenticated}
          component={publicRoute.component}
          // routes={route.routes}
          exact
          path={publicRoute.path}
          key={"private"}
        />
      );
    }

    if (!authenticated) {
      return (
        <Redirect
          to={`/sign-in?nextUrl=${nextUrl}${this.props.location.search}`}
        />
      );
    }

    if (checkAllSystemRoute(this.props.location.pathname)) {
      return <AccessDeniedPage />;
    }

    // return <ErrorPage errorType='error404' />;
    return <NotFoundPage />;
    // return <Redirect to='/'/>;
  }
}

/*eslint-disable-nexline */
export default withRouter(AppRoutes);
// export default AppRoutes;



// WEBPACK FOOTER //
// ./src/portal_homeowner/router.js